'use strict';

exports.__esModule = true;
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HeadGoverness2 = require('./HeadGoverness');

var _HeadGoverness3 = _interopRequireDefault(_HeadGoverness2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MiddlewareGoverness = function (_HeadGoverness) {
  _inherits(MiddlewareGoverness, _HeadGoverness);

  function MiddlewareGoverness() {
    _classCallCheck(this, MiddlewareGoverness);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (MiddlewareGoverness.__proto__ || Object.getPrototypeOf(MiddlewareGoverness)).call(this, args));

    _this.middleware = args[0];
    return _this;
  }

  _createClass(MiddlewareGoverness, [{
    key: 'governed',
    value: function governed() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.middleware.apply(this, [this].concat(args));

      _HeadGoverness3.default.prototype.governed.apply(this, args);
    }
  }]);

  return MiddlewareGoverness;
}(_HeadGoverness3.default);

exports.default = MiddlewareGoverness;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/governesses/MiddlewareGoverness.js
// module id = 1V67
// module chunks = 0